import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, NgZone, LOCALE_ID, Inject } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { v4 as uuidv4 } from 'uuid';
import { AuthService } from '../shared/services/auth.service';
import { ProfileService } from '../shared/services/profile.service';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor(
    public afs: AngularFirestore,   // Inject Firestore service
    public afAuth: AngularFireAuth, // Inject Firebase auth service
    public router: Router,
    public ngZone: NgZone, // NgZone service to remove outside scope warning
    private profileService:ProfileService,
    private http: HttpClient,
    private auth: AuthService,
    @Inject(LOCALE_ID) private locale: string
  ) { }

  async getCultureId(){
    switch (this.locale) {
      case 'en':
        return 1

      case 'sv':
        return 2

      case 'cs':
        return 3

      case 'es':
        return 4
        
      case 'nb':
        return 5

      case 'de':
        return 6

      case 'da':
        return 7

      case 'fr':
        return 8

      case 'sk':
        return 9

      case 'hu':
        return 10
      default:
        return 1
    }
  }
  
  async getPaymentMethods(){
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };
    return this.http.get(`${environment.api_url}order/paymentmethods`, httpOptions).toPromise()
  }

  async postOrder(order){
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };
    return this.http.post(`${environment.api_url}order/`, order, httpOptions).toPromise()
  }

  saveOrder(doc) {
    doc.formatedDate = new Date().toDateString()
    // doc.customer = {name:}
    const userID = JSON.parse(localStorage.getItem('user')).uid;
    doc.uid = userID;
    return this.afs.collection('orders').add(doc);
  }
  
  //For admin
  
  async getAllOrders() {
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };
    return this.http.get(`${environment.api_url}order`, httpOptions).toPromise()
  
  }

  async getOrders() {
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };
    return this.http.get(`${environment.api_url}order/user`, httpOptions).toPromise()
   
  }
  getFirebaseOrders(){
    const userID = JSON.parse(localStorage.getItem('user')).uid;
    return this.afs.collection('orders', ref => ref.where('uid', '==', userID)).valueChanges();
  }

  async getOrderArticles(id) {
    
    let culture_id = await this.getCultureId();
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };
    return this.http.get(`${environment.api_url}order/order_articles/${id}/${culture_id}`, httpOptions).toPromise()
  }
  async getOrderArticlesAttributes(id) {
    
    let culture_id = await this.getCultureId();
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };

    return this.http.get(`${environment.api_url}order/order_articles_attributes/${id}/${culture_id}`, httpOptions).toPromise()
  }

  async getOrganizationByid(id) {
    
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };

    return this.http.get(`${environment.api_url}organization/${id}`, httpOptions).toPromise()
  }

  async getShippingMethod() {
    
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };
    return this.http.get(`${environment.api_url}order/shipping`, httpOptions).toPromise()
  }

  async getDiscounts() {
    
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };
    return this.http.get(`${environment.api_url}order/discount`, httpOptions).toPromise()
  }

  async getCountries() {
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };

    return this.http.get(`${environment.api_url}order/countries`, httpOptions).toPromise()
  }

  async getCurrencyRateByName(country) {
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };

    return this.http.get(`${environment.api_url}order/currency_rate/${country}`, httpOptions).toPromise()
  }

  async getProvinces() {
    
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };

    return this.http.get(`${environment.api_url}order/provinces`, httpOptions).toPromise()
  }
}
